import React from "react";
import Icon from "./Icon";

/* local copy for now (we'll move to utils later without behavior change) */
const AVATAR_GRADIENTS = [
  ["#4ADE80", "#16A34A"],
  ["#38BDF8", "#0284C7"],
  ["#FCD34D", "#D97706"],
  ["#C084FC", "#7C3AED"],
  ["#FB7185", "#BE123C"],
  ["#FB923C", "#C2410C"],
  ["#34D399", "#059669"],
  ["#A78BFA", "#5B21B6"],
];

const getAvatarColors = (name = "") => {
  if (!name || typeof name !== "string") return AVATAR_GRADIENTS[0];
  return AVATAR_GRADIENTS[name.charCodeAt(0) % AVATAR_GRADIENTS.length];
};

export default function ActiveSpeakerBanner({ speaker }) {
  if (!speaker) return null;

  const { name, image, role, isMuted } = speaker;

  const roleLabel =
    role === "host" ? "Host" : role === "speaker" ? "Speaker" : null;

  const roleColor =
    role === "host"
      ? "var(--jt-gold)"
      : role === "speaker"
        ? "var(--jt-purple)"
        : "var(--jt-accent)";

  const [c1, c2] = getAvatarColors(name);

  return (
    <div className="jt-activeSpeaker">
      <div className="jt-activeSpeaker-inner">
        <div className="jt-bars" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
        </div>

        <div
          className="jt-as-avatar"
          style={{ background: `linear-gradient(135deg, ${c1}, ${c2})` }}
        >
          {image ? (
            <img src={image} alt="" />
          ) : (
            <span>{(name?.[0] || "?").toUpperCase()}</span>
          )}
          <i className="jt-as-dot" />
        </div>

        <div className="jt-as-info">
          <div className="jt-as-nameRow">
            <div className="jt-as-name" title={name}>
              {name}
            </div>

            {roleLabel && (
              <div
                className="jt-rolePill"
                style={{ borderColor: roleColor, color: roleColor }}
              >
                {roleLabel}
              </div>
            )}
          </div>

          <div className="jt-as-sub">Speaking now</div>
        </div>

        <div
          className={`jt-as-mic ${isMuted ? "off" : "on"}`}
          title={isMuted ? "Muted" : "Mic on"}
        >
          {isMuted ? <Icon name="micOff" /> : <Icon name="mic" />}
        </div>
      </div>
    </div>
  );
}
